#ifdef GL_ES
precision mediump float;
#endif

attribute vec3  color;
attribute float sizes;
attribute float opacity;

attribute float randomValue;

varying vec3  vColor;
varying float vAlpha;
varying float vOpacity;
varying float vRandomValue;

uniform vec3  cameraPos; 
uniform vec3  center;        
uniform vec3  sunPos;       

uniform float maxRadius;   
uniform float maxCamDist;    
uniform float minFalloffExp; 
uniform float maxFalloffExp;  

void main() {
    vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;

    float camDistNorm = clamp(length(cameraPos - center) / maxCamDist, 0.0, 1.0);

    vec3 tailNormal = normalize(sunPos - center);

    vec3 toCamera    = normalize(cameraPos - worldPos);
    float alignment = clamp(dot(toCamera, tailNormal) * 0.5 + 0.5, 0.0, 1.0);

    float dynamicExp = mix(minFalloffExp, maxFalloffExp, alignment);

    float wCam = pow(camDistNorm, dynamicExp);

    float d     = length(worldPos - center);
    float wDist = clamp((maxRadius - d) / maxRadius, 0.0, 1.0);

    float w = wCam * wDist;

    vColor   = color;
    vAlpha   = 1.0;
    vOpacity = opacity;
    vRandomValue = randomValue;
    vec4 mvPos = modelViewMatrix * vec4(position, 1.0);
    float ps   = sizes * (300.0 / -mvPos.z) * w;
    gl_PointSize = ps;
    gl_Position  = projectionMatrix * mvPos;
}
